import { useEffect, useState } from 'react';
import ErrorBanner from '../banners/ErrorBanner';

export default function ShowCookieWarning() {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!navigator.cookieEnabled) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowWarning(true);
    }
  }, []);

  if (!showWarning) {
    return null;
  }

  return (
    <ErrorBanner data-testid="cookie-error">
      Your browser doesn&apos;t accept cookies. Please enable cookies in your
      browser settings.
    </ErrorBanner>
  );
}
